import { useAuscultation } from '~/hooks/useAuscultation';
import Button from '~/components/Button';
import CircleArrowIcon from '~/assets/icons/circle-arrow.svg?react';
import CheckIcon from '~/assets/icons/success.svg?react';
import styles from './AudioUploadStateIndicator.module.scss';

type Props = {
  recordingLocation: string;
};

export default function AudioUploadStateIndicator({ recordingLocation }: Props) {
  const { hasRecording, isRecordingSaved, saveUnsavedNextGenRecordings } = useAuscultation();

  if (!hasRecording(recordingLocation) || isRecordingSaved(recordingLocation) === undefined) {
    return null;
  }

  return (
    <>
      {isRecordingSaved(recordingLocation) ? (
        <span className={styles.saved}>
          <CheckIcon />
        </span>
      ) : (
        <span className={styles.unsaved}>
          Kunde inte sparas
          <Button variant="text" onClick={saveUnsavedNextGenRecordings}>
            <CircleArrowIcon width={16} height={16} />
          </Button>
        </span>
      )}
    </>
  );
}
